//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Consistencia() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }





  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Consistências e padrões na comunicação
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que o software científico deve manter o mesmo padrão de comunicação em todas as suas interações com o usuário, 
              principalmente no que diz respeito a cores, ícones e textos. Além disso, é importante verificar se o domínio da aplicação do software apresenta algum padrão específico 
              de comunicação que deve ser seguido para serem mantidos os significados. Exemplo: Em um software científico, é utilizada a técnica de mapa de calor (heatmap) para 
              demonstrar concentração de dados em uma região e para demonstrar a relevância de cada dado. Se, na primeira função, for utilizada a cor vermelha para demonstrar a 
              região de maior concentração de dados e for utilizada a cor azul para mostrar a região com menor concentração de dados, as mesmas cores e significados devem ser 
              utilizados na outra função, ou seja, para mostrar os dados de maior relevância deve ser utilizada a cor vermelha e para demonstrar os dados de menor relevância, o azul; </strong> </p>
            <p align="justify"> <strong> A heurística Consistência e padrões na comunicação, foi subdivida em dois critérios de análise, a saber: Padrão nas comunicações (C1) e 
              Significado consistente das comunicações (C2) </strong> </p>
            <br></br>
              <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1.C1) Os ícones utilizados no software representam sempre as mesmas funções? Indique o número de ícones analisados (N) e a quantidade de ícones coerentes encontrados (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de ícones analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de ícones coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P2.C1)   As cores utilizadas no software apresentam sempre o mesmo padrão de uso? Indique o número de cores analisadas (N) e a quantidade de cores coerentes encontradas (Q). 
              Exemplo: Cor verde para confirmar uma ação, independente do texto do botão. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de cores analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de cores coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P3.C1)   O tratamento do usuário durante as comunicações segue um padrão? Indique o número de comunicações analisadas (N) e a quantidade de comunicações coerentes 
              encontradas (Q). Exemplo: Em uma mensagem de erro aparece escrito na tela ’Você não pode fazer isso’ e em outra mensagem de erro aparece escrito na tela ’O usuário 
              não pode realizar essa ação’. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de comunicações analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P4.C1)   O software apresenta um padrão de termos sinônimos? Indique o número de termos analisados (N) e a quantidade de termos coerentes encontradas (Q). 
              Exemplo: Em um momento do software, aparecem ’Cadeia de DNA’, ’Sequência de DNA’, ’String de DNA’ ou ’Fragmento de DNA’, etc. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de termos analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de termos coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1.C2)   Os ícones utilizados no software apresentam sempre o mesmo significado? Indique o número de ícones analisados (N) e a quantidade de ícones coerentes 
              encontrados (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de ícones analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['5_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'5_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de ícones coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['5_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'5_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P2.C2)   Os textos utilizados no software apresentam sempre o mesmo significado? Indique o número de textos analisados (N) e a quantidade de textos coerentes 
              encontrados (Q). <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de textos analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['6_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'6_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de textos coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['6_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'6_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P3.C2)   As cores utilizadas no software apresentam sempre o mesmo significado e seguem o comum para a área de aplicação? Indique o número de cores analisadas (N) e 
              a quantidade de cores coerentes encontradas (Q). Exemplo: Cor vermelho é utilizado para indicar erros não pode ser utilizada para destacar um resultado. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de cores analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['7_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'7_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de cores coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['7_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'7_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>

            <button onClick={(e)=>{

            }} className="btn btn-success btn-lg w-100">
                          Gerar resultado
                        </button>
            <ModalMensagem/>

           












          </div>
        </div>
      </div>

    </div>
  );
}
